import React, { FC } from 'react'
import { Col, Container, Hidden, Row, useScreenClass } from 'react-grid-system'
import styled from 'styled-components'
import CONTACT from '../../assets/contact.jpg'
import Form from './Form'

const Section = styled.section<{ isDesktop: boolean }>`
  padding: ${(props) => (props.isDesktop ? '4.75rem 2rem 5.5rem' : '3rem 1rem 3.5rem')};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #FAFAF8;
`

/* A light card rather than the old mid-grey block: white labels on #828282
   only cleared 3.9:1, under the 4.5:1 the brand guidelines call for. */
const Card = styled.div`
  background: #ffffff;
  border: 1px solid #E8E8E6;
  border-radius: var(--radius-lg);
  overflow: hidden;
  box-shadow: 0 20px 46px rgba(0, 0, 0, 0.07);
`

const Media = styled.div`
  height: 100%;
  min-height: 420px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`

const Panel = styled.div<{ isDesktop: boolean }>`
  padding: ${(props) => (props.isDesktop ? '3.25rem 3rem' : '2rem 1.5rem 2.5rem')};

  h2 {
    color: #000000;
    margin: 0 0 0.35rem;
  }

  p.lede {
    margin: 0 0 2rem;
    color: ${(props) => props.theme.colors.darkGray};
    font-size: var(--fs-body-sm);
  }
`

const Contact: FC = () => {
  const screenClass = useScreenClass()
  const isDesktop = ['md', 'lg', 'xl'].includes(screenClass)

  return (
    <Section id="contact" isDesktop={isDesktop}>
      <Container style={{ maxWidth: '1120px' }}>
        <Card>
          <Row nogutter>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Hidden xs sm md>
                <Media>
                  <img loading="lazy" src={CONTACT} alt="Podcast studio" />
                </Media>
              </Hidden>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Panel isDesktop={isDesktop}>
                <h2>Have a question?</h2>
                <p className="lede">
                  Tell us what you&rsquo;re working on and we&rsquo;ll get back
                  to you.
                </p>
                <Form />
              </Panel>
            </Col>
          </Row>
        </Card>
      </Container>
    </Section>
  )
}

export default Contact
